
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getBookingDomains } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormSubstatusList = () => {

    const { t } = useTranslation('booking');

    const statusList = useWatch<IFormValuesBookingsFilter, 'statusList'>({
        name: 'statusList'
    });

    const domainsQuery = useQuery({
        queryKey: [ReactQueryKey.BookingDomains],
        queryFn: getBookingDomains,
        enabled: false
    });

    const options = useMemo(() => {
        if (!domainsQuery.data) {
            return []
        };
        const statuses = domainsQuery.data.statuses;
        const substatutes = domainsQuery.data.substatuses;
        const result = substatutes
            .filter(v => statusList.length === 0 || statusList.find(w => w.code === v.status));
        return result;
    }, [
        statusList,
        domainsQuery.data
    ]);

    const handleOnOpen = () => {
        if(domainsQuery.data == undefined) 
            domainsQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="substatusList"
            label={t('label.substatus')}
            options={options}
            loading={domainsQuery.isLoading}
            isOptionEqualToValue={(option, value) => option?.code === value?.code}
            getOptionLabel={(option) => t(`substatus.${option.code}`) + ' - ' + t(`status.${option.status}`)}
            multiple
            onOpen={handleOnOpen}
        />
    );
};

export default FormSubstatusList;
